module.exports = __webpack_public_path__ + "img/anke-easy-yoga-2.52f0e811.jpg";